function Viewport(breakpoints) {

    // Get the breakpoint config
    this.breakpoints = breakpoints;

    // Constuct the breakpoint for the media query
    this.mediaQuery = function(breakpoint) {
        return '(' + this.breakpoints[breakpoint].type + ': ' + this.breakpoints[breakpoint].size + 'px)';
    }

    // Check if the media query matches
    this.matchMedia = function(breakpoint) {
        return window.matchMedia(this.mediaQuery(breakpoint));
    }

    // Check if the media query matches
    this.matches = function(breakpoint) {
        return window.matchMedia(this.mediaQuery(breakpoint)).matches;
    }

    // Construct the custom media query
    this.customMediaQuery = function(breakpoint) {
        return breakpoint;
    }

    // Check if the custom media query matches
    this.customMatchMedia = function(breakpoint) {
        return window.matchMedia(this.customMediaQuery(breakpoint));
    }

    // Check if the custom media query matches
    this.customMatches = function(breakpoint) {
        return window.matchMedia(this.customMediaQuery(breakpoint)).matches;
    }

    // Watch for viewport resize
    this.resize = function(callback) {
        var windowResizing;

        window.addEventListener('resize', function() {
            clearTimeout(windowResizing);
            windowResizing = setTimeout(function() {
                if (typeof callback == 'function') {
                    callback();
                }
            }, 100);
        });
    }
}

(function (app) {
    var preventScroll = {
        active: false,
        on: () => {
            var htmlEl = document.querySelector('html');
            var body = document.body;

            // Determine the `scrollTop` to use. Some browsers require checking the
            // `body`, others use `html`.
            var bodyScrollTop = body.scrollTop;
            var htmlScrollTop = htmlEl.scrollTop;
            var scrollTop = bodyScrollTop ? bodyScrollTop : htmlScrollTop;

            // Store the current value of the htmlEl's styles – we're about to override
            // them.
            this.currentPosition = htmlEl.style.position;
            this.currentOverflow = htmlEl.style.overflowY;
            this.currentWidth = htmlEl.style.width;

            // Fixing the position of the `htmlEl` prevents the page from scrolling
            // at all.
            htmlEl.style.position = 'fixed';
            // Setting `overflowY` to `scroll` ensures that any scrollbars that are
            // around stick around. Otherwise, there would be a "jump" when the page
            // becomes unscrollable as the bar would vanish.
            htmlEl.style.overflowY = 'scroll';
            // This makes sure that the page doesn't collapse (usually your CSS will
            // prevent this, but it's best to be safe)
            htmlEl.style.width = '100%';
            // Scoot down the `htmlEl` to be in the same place that the user had
            // scrolled to.
            htmlEl.style.top = (0 - scrollTop) + 'px';

            // Set active state
            this.active = true;
        },

        off: () => {
            var htmlEl = document.querySelector('html');
            var body = document.body;

            // Reset `htmlEl` to the original styles.
            htmlEl.style.position = this.currentPosition;
            htmlEl.style.overflowY = this.currentOverflow;
            htmlEl.style.width = this.currentWidth;

            // Retrieve our original scrollTop from the htmlEl's top
            var scrollTop = -parseInt(htmlEl.style.top);
            // Return us to the original scroll position. Once again, we set this on
            // both the `body` and the `htmlEl` to be safe.
            htmlEl.scrollTop = scrollTop;
            body.scrollTop = scrollTop;

            // Unset active state
            this.active = false;
        }
    }
    app.plugins = app.plugins || {};
    app.plugins.preventScroll = preventScroll;
})(window.Inchbald = window.Inchbald || {});
//=require polyfills/object.forEach.js

(function (app) {
    function Header() {
        let viewport = new Viewport(Inchbald.breakpoints);

        this.outerWrapper = document.querySelector('.outer-wrapper');
        this.body = document.querySelector('body');
        this.el = document.querySelector('.js-header');
        this.headerMarker = document.querySelector('.js-header-marker');

        this.heights = {};

        if (this.el) {
            this.toggle = this.el.querySelector('.js-header-nav__toggle');
            this.itemToggle = this.el.querySelectorAll('.js-header__item-toggle');
        }

        this.init = () => {
            if (this.el) {
                this.watchPageScroll();
                this.watchToggle();
                this.watchResize();
                this.trapFocus();
                this.setDocHeight();
            }
        }

        this.watchPageScroll = () => {
            this.checkPageScroll();
            document.addEventListener('scroll', this.checkPageScroll.bind(this));
        }

        this.watchToggle = () => {
            this.toggle.addEventListener('click', () => {
                if (viewport.matches('nav')) {
                    if (this.isActiveNav()) {
                        this.deactivateNav();
                        this.resetNavheight();
                        this.setItemAria(this.toggle, false);

                        app.plugins.preventScroll.off();
                    } else {
                        this.activateNav();
                        this.setNavheight();
                        this.setItemAria(this.toggle, true);

                        app.plugins.preventScroll.on();
                    }
                }
            });
        }

        this.setDocHeight = () => {
            document.documentElement.style.setProperty('--vh', `${window.innerHeight/100}px`);
        };
        
        this.watchResize = () => {
            viewport.resize(() => {
                if (viewport.matches('nav')) {
                    if (this.isActiveNav()) {
                        this.setNavheight();
                    }
                } else {
                    this.resetNavheight();
                    this.deactivateFixed();
                }
            })

            viewport.matchMedia('nav').addListener((e) => {
                if (!e.matches) {
                    if (this.isActiveNav()) {
                        this.deactivateNav();
                        this.setItemAria(this.toggle, false);

                        app.plugins.preventScroll.off();
                    }
                }
            });
        }

        // Check how far the page has scrolled
        this.checkPageScroll = () => {
            if (viewport.matches('nav')) {
                if (this.atTop()) {
                    this.deactivateFixed();
                } else {
                    this.activateFixed();
                }
            }
        }

        // Is the page scrolled to the top
        this.atTop = () => {
            var offset = parseInt(window.getComputedStyle(this.outerWrapper, null).getPropertyValue('padding-top'));
            if (viewport.matches('nav')) {
                return this.headerMarker.getBoundingClientRect().top >= offset;
            } else {
                if (this.headerMarker.clientHeight == this.heights.headerNavContainer) {
                    return this.headerMarker.getBoundingClientRect().top >= offset;
                } else {
                    return this.headerMarker.getBoundingClientRect().top + this.heights.headerTop >= offset;
                }
            }
        }

        this.trapFocus = () => {
            const KEYCODE_TAB = 9;
            const focusableEls = this.el.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
            let visibleFocusableEls = [];

            focusableEls.forEach((el) => {
                if (el.getBoundingClientRect().width > 0) {
                    visibleFocusableEls.push(el);
                }
            });

            const firstFocusableEl = visibleFocusableEls[0];
            const lastFocusableEl = visibleFocusableEls[visibleFocusableEls.length - 1];

            this.el.addEventListener('keydown', (e) => {
                const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

                if (!isTabPressed || !this.isActiveNav()) {
                    return;
                }

                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableEl) {
                        lastFocusableEl.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastFocusableEl) {
                        firstFocusableEl.focus();
                        e.preventDefault();
                    }
                }

            });
        }

        this.setItemAria = (item, status) => {
            item.setAttribute('aria-expanded', status);
        }

        this.activateNav = () => {
            this.body.setAttribute('data-header-nav-loading', true);
            setTimeout(() => {
                this.body.setAttribute('data-header-nav', true);
            }, 1);
        }

        this.deactivateNav = () => {
            this.body.setAttribute('data-header-nav', false);
            setTimeout(() => {
                this.body.setAttribute('data-header-nav-loading', false);
            }, 300);
        }

        // Activate the fixed header
        this.activateFixed = () => {
            this.el.classList.add('header--fixed');
        }

        // Deactivate the fixed header
        this.deactivateFixed = () => {
            this.el.classList.remove('header--fixed');
            this.headerMarker.classList.remove('header-marker__height--active');

            if (!viewport.matches('nav')) {
                this.headerMarker.style.top = this.heights.headerTop + 'px';
                this.headerMarker.style.height = this.heights.headerNavContainer + 'px';
            } else {
                this.headerMarker.style.top = 0;
                this.headerMarker.style.height = this.heights.headerTop + 'px';
            }
        }

        this.isActiveNav = () => {
            return this.body.dataset.headerNav === 'true';
        }

        this.setNavheight = () => {
            this.el.style.height = (window.innerHeight - 40) + 'px';
        }

        this.resetNavheight = () => {
            this.el.style.height = null;
        }
    }

    const header = new Header();
    header.init();

    app.Header = Header;
})(window.Inchbald = window.Inchbald || {});